export default class ArenaTariffFreePlaces {
    SectorCode: number = 0;
    Count: number = 0;
}